<!-- 班级历史成绩对比四象限图 -->
<template>
    <div class="fourQuadrants-box">
        <div ref="chartEl" :id="'historyChart' + id_type" class="historyChart"></div>
    </div>
</template>
<script>
import {
    buildMarkLineData,
    resolveQuadrantConfig,
    scaleRawXyByGradeK0,
    resolveAxisExtent,
} from '../report/quadrantGradeAxis.js';

function buildScatterFromStuList(stuList, gradeValue, factorMap) {
    return (stuList || []).reduce((acc, item) => {
        if (!item) return acc;
        const rawX = (Number(item.centerPos) + Number(item.gridSize) + Number(item.comboRel) + Number(item.multiDist)) / 4;
        const rawY = (Number(item.glyphGrav) + Number(item.strokeRel) + Number(item.rewindRel)) / 3;
        const scaled = scaleRawXyByGradeK0(rawX, rawY, gradeValue, factorMap);
        if (!scaled) return acc;
        acc.push({
            name: item.stuName,
            value: [scaled.x, scaled.y],
        });
        return acc;
    }, []);
}

const MARK_LINE = {
    symbol: ['none', 'arrow'],
    silent: true,
    lineStyle: { type: 'solid', color: '#aaa' },
};

export default {
    props: ['id_type', 'chartData', 'GradeValue', 'fourQuadrantsReportTitle', 'factorMap'],
    data() {
        return {
            chartInstance: null,
            resizeHandler: null,
        };
    },
    computed: {
        gradeValue() {
            const v = this.GradeValue;
            return v != null && v !== '' ? v : null;
        },
        quadrantConfig() {
            return resolveQuadrantConfig(this.gradeValue);
        },
        scatterData() {
            const list = this.chartData && this.chartData.stuList;
            return buildScatterFromStuList(list, this.gradeValue, this.factorMap);
        },
        chartOption() {
            if (!this.chartData || !this.scatterData.length) return null;
            const { axisX, axisY } = this.quadrantConfig;
            const { min, max } = resolveAxisExtent(this.scatterData, axisX, axisY);
            const valueAxis = {
                type: 'value',
                min,
                max,
                axisLine: { onZero: false },
                splitLine: { show: false },
                interval: 10,
            };
            return {
                title: {
                    text: this.fourQuadrantsReportTitle,
                    left: 'center',
                    textStyle: { fontWeight: 'normal' },
                },
                tooltip: {
                    show: true,
                    trigger: 'item',
                    formatter: (params) => {
                        const effort = Number(params.value[0]).toFixed(2);
                        const talent = Number(params.value[1]).toFixed(2);
                        return `${params.name}( 努力:${effort},天赋:${talent})`;
                    },
                    position: 'right',
                },
                dataZoom: [{ type: 'inside', startValue: min, endValue: max }],
                grid: { left: '15%', right: '15%' },
                xAxis: { ...valueAxis },
                yAxis: { ...valueAxis },
                series: [{
                    type: 'scatter',
                    label: {
                        show: true,
                        position: 'top',
                        formatter: params => params.data.name,
                        fontSize: 10,
                        color: '#333',
                    },
                    data: this.scatterData,
                    itemStyle: { color: '#5470C6' },
                    markLine: {
                        ...MARK_LINE,
                        data: buildMarkLineData(axisX, axisY),
                    },
                }],
            };
        },
    },
    watch: {
        chartData: { handler: 'scheduleInitChart', deep: true },
        GradeValue: 'scheduleInitChart',
        factorMap: { handler: 'scheduleInitChart', deep: true },
        fourQuadrantsReportTitle: 'scheduleInitChart',
    },
    mounted() {
        this.scheduleInitChart();
    },
    beforeDestroy() {
        if (this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler);
            this.resizeHandler = null;
        }
        this.disposeChart();
    },
    methods: {
        scheduleInitChart() {
            this.$nextTick(() => this.initChart());
        },
        disposeChart() {
            if (!this.chartInstance) return;
            try {
                this.chartInstance.dispose();
            } catch (e) {
                /* 容器已卸载时可能抛错 */
            }
            this.chartInstance = null;
        },
        bindResizeOnce() {
            if (this.resizeHandler) return;
            this.resizeHandler = () => {
                if (this.chartInstance) {
                    this.chartInstance.resize();
                }
            };
            window.addEventListener('resize', this.resizeHandler);
        },
        initChart() {
            const el = this.$refs.chartEl;
            if (!el) return;

            const option = this.chartOption;
            if (!option) {
                this.disposeChart();
                return;
            }

            if (!this.chartInstance) {
                this.chartInstance = this.$echarts.init(el);
                this.bindResizeOnce();
            }
            this.chartInstance.setOption(option, true);
            this.$nextTick(() => {
                if (this.chartInstance) {
                    this.chartInstance.resize();
                }
            });
        },
    },
};
</script>
<style lang="less">
.fourQuadrants-box {
    box-sizing: border-box;
    padding: 0 20px;
    width: 100%;
    height: 600px;
    margin-bottom: 30px;

    .historyChart {
        width: 100%;
        height: 100%;
    }
}
</style>
